import { useLocation } from "react-router";
import React from "react";

import AdInContent from "~/components/ads/AdInContent";
import H1 from "~/components/H1";
import { getLocale } from "~/i18n";


interface Props {
  name: string,
  description?: string|null,
  // children: React.ReactNode,
}

const ToolHeader: React.FC<Props> = (
  {
    name,
    description = null,
    // children = null,
  }
) => {

  const locale = getLocale(useLocation().pathname);

  return (
    <>
      <header className="mt-4 pb-4">
        <H1>{name}</H1>
        {description !== null  ? (
          <p className="pt-4 text-lg md:text-xl">
            {description.endsWith(".") || description.endsWith("?") || description.endsWith("!") ? description : description + "."}
          </p>
        ) : null}
      </header>
      { locale === "ru"
        ? <AdInContent type="yandex" adId="R-A-7013740-2" />
        : <AdInContent type="google" adId="2142145936" />
      }
    </>
  );
};

export default ToolHeader;